import { Box, Typography, Link, Stack } from "@mui/material";
import { EmailOutlined, Phone, Sms } from "@mui/icons-material";
import { useContext } from "react";
import { StoreContext } from "layout/HomeLayout";
import { snsLink } from "layout/HomeLayout/footer";
import { path } from "config/path";

const Contact = () => {
  const { store } = useContext(StoreContext);
  return (
    <Box display='block' sx={{ textAlign: 'center', p: '2em' }}>
      <Box>
        <Typography variant="h2" sx={{ color: '#4A2E1C', py: '0.5em' }}>Contact us</Typography>
        <Stack sx={{ textAlign: 'center', width: '100%' }}>
          <Link href={`mailto:${store.email}`} color='inherit' underline="none" target='_blank'
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pb: '1em' }}>
            <EmailOutlined /><Typography variant="h4">&nbsp;{store.email}</Typography>
          </Link>
          <Box display='flex' sx={{ py: '1em', alignItems: 'center', justifyContent: 'center' }}>
            {snsLink(store.sns, '4em')}&nbsp;{snsLink(store.sns2, '4em')}
          </Box>
          <Box
            component="img"
            src={`${path.basename}/images/insta.jpg`}
            alt="Instagram"
            sx={{ width: "100%", height: "auto" }}
            onClick={() => window.open(store.sns, '_blank')}
          />
        </Stack>
      </Box>
    </Box>
  )
}

export default Contact;